// src/screens/POS/POSSummaryScreen.js
import React, { useContext, useEffect, useState } from 'react';
import CountContext from '../../context/CountContext.js';

export default function POSSummaryScreen({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const { report } = state;

  // List of report fields for dynamic rendering
  const fields = [
    { label: 'Credit Tips', field: 'creditTips' },
    { label: 'Total Charges', field: 'totalCharges' },
    { label: 'Gift Card Payment', field: 'giftCardPayment' },
    { label: 'Gift-Card Sales (unredeemed)', field: 'giftCardSold' },
    { label: 'Total Sales (inc. tax)', field: 'totalSales' },
    { label: 'Total Minus Gift', field: 'totalMinusGift' },
    { label: 'Total Tax', field: 'totalTax' }
  ];

  // Local state to preserve trailing zeros in input
  const [inputs, setInputs] = useState(() => {
    const init = {};
    fields.forEach(({ field }) => {
      init[field] = report[field].toFixed(2);
    });
    return init;
  });

  // Sync local inputs when context report changes (e.g. adjustment)


  // Generic handler to sanitize and dispatch text input
  const handleTextChange = (field) => (e) => {
    let raw = e.target.value;
    // Remove any invalid characters (allow digits and '.')
    raw = raw.replace(/[^0-9.]/g, '');
    // Split into integer and decimal parts
    const parts = raw.split('.');
    const intPart = parts[0] || '';
    // Preserve up to two decimal digits
    const decPart = parts.length > 1 ? parts[1].slice(0, 2) : '';
    // Reconstruct, preserving the dot if the user typed it
    const text = parts.length > 1 ? `${intPart}.${decPart}` : intPart;

    setInputs(prev => ({ ...prev, [field]: text }));
    const num = parseFloat(text) || 0;
    dispatch({ type: 'UPDATE_REPORT_FIELD', payload: { field, value: num } });
  };

  // Auto-default totalMinusGift when no gift card used when no gift card used
  // keep totalMinusGift in sync: sales minus redeemed gift-cards

  useEffect(() => {
    const newMinusGift = report.totalSales - report.giftCardPayment;
    dispatch({
      type: 'UPDATE_REPORT_FIELD',
      payload: { field: 'totalMinusGift', value: newMinusGift }
    });
  
  }, [report.totalSales, report.giftCardPayment, dispatch]);
// inside POSSummaryScreen
// after your inputs state setup...
useEffect(() => {
  if (state.reportAdjusted) {
    // only when adjustment has been applied
    setInputs(prev => ({
      ...prev,
      totalSales: state.report.totalSales.toFixed(2),
      totalMinusGift: state.report.totalMinusGift.toFixed(2)
    }));
  }
}, [state.reportAdjusted, state.report.totalSales, state.report.totalMinusGift]);

return (
  <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-4">
    <h2 className="text-2xl font-bold">POS Summary</h2>

    {fields.map(({ label, field }) => (
      <div key={field} className="space-y-1">
        <div className="flex items-center space-x-4">
          <label className="w-40">{label}:</label>
          <input
            type="number"
            placeholder="0.00"
            value={inputs[field]}
            onChange={handleTextChange(field)}
            className="border rounded p-1 flex-1"
          />
        </div>
        {field === 'giftCardSold' && (
          <p className="text-sm text-gray-500">
            Enter any gift-card purchases that haven’t been redeemed yet.
          </p>
        )}
      </div>
    ))}


    <div className="flex justify-between mt-6">
      <button onClick={onBack} className="px-4 py-2 bg-gray-300 rounded">
        Back
      </button>
      <button onClick={onNext} className="px-4 py-2 bg-blue-500 text-white rounded">
        Confirm POS Summary
      </button>
    </div>
  </div >
);
}
